import React from 'react';
import './GrowBusiness.css';

export default function GrowBusiness() {
  return (
    <section className="grow-business-section section-padding" id="grow">
      <div className="container grow-business-container">
        <div className="grow-grid">
          {/* Left Column: Heading and description */}
          <div className="grow-content-panel">
            <h2 className="grow-title">
  <span className="grow-title-line1">Grow Your Business With</span>
  <span className="grow-title-line2 text-gradient">Haatza</span>
</h2>
            <p className="grow-text">
              Ready to grow your business with Haatza? Our innovative e-commerce platform provides you with all the tools you need for success! From seamless integration to advanced marketing strategies, we're committed to supporting your growth every step of the way.
            </p>
            <a href="/grow" className="grow-learn-more-link">
              <button className="grow-learn-more-btn">Learn More</button>
            </a>
          </div>

          {/* Right Column: 2x2 grid of features */}
          <div className="grow-cards-grid">
            {/* Card 1 */}
            <div className="grow-card">
              <div className="grow-icon-wrapper blue-icon">
                <img src="https://static.wixstatic.com/media/fe689e_744f93af1a3b407ba520069c674d218f~mv2.png/v1/fill/w_55,h_55,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/icons8-tag-94.png" alt="Lowest Shipping Costs" className="grow-card-img-icon" />
              </div>
              <h3 className="grow-card-title">Lowest Shipping Costs</h3>
              <p className="grow-card-text">
                Sell your products across India to over 28,000+ pincodes at lowest delivery cost.
              </p>
            </div>

            {/* Card 2 */}
            <div className="grow-card">
              <div className="grow-icon-wrapper orange-icon">
                <img src="https://static.wixstatic.com/media/fe689e_375a9f0e0f2c44c4a30c7b1a6bcf8a06~mv2.png/v1/fill/w_55,h_55,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/icons8-features-list-94.png" alt="Ads to grow more" className="grow-card-img-icon" />
              </div>
              <h3 className="grow-card-title">Ads to grow more</h3>
              <p className="grow-card-text">
                Use selling tools like Haatza Ads to be more visible and sell more products. Currently, not available for Sellers who don't have a Regular GSTIN
              </p>
            </div>

            {/* Card 3 */}
            <div className="grow-card">
              <div className="grow-icon-wrapper green-icon">
                <img src="https://static.wixstatic.com/media/fe689e_1db416e046564cb1b0ae00781c2a8916~mv2.png/v1/fill/w_55,h_55,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/icons8-growth-94.png" alt="Same Day Dispatch Program" className="grow-card-img-icon" />
              </div>
              <h3 className="grow-card-title">Same Day Dispatch Program</h3>
              <p className="grow-card-text">
                Sign up for the quick Next Day Dispatch (NDD) Program and get higher visibility and your own Account Manager
              </p>
            </div>

            {/* Card 4 */}
            <div className="grow-card">
              <div className="grow-icon-wrapper purple-icon">
                <img src="https://static.wixstatic.com/media/fe689e_b2f59dd317ad41e5b17e9ec48e677dd7~mv2.png/v1/fill/w_55,h_55,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/icons8-search-94.png" alt="Business Insights" className="grow-card-img-icon" />
              </div>
              <h3 className="grow-card-title">Business Insights</h3>
              <p className="grow-card-text">
                Use product & price recommendations so that you're always on top of your business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
